const getJSON = require('get-json')

import { RequestManager } from './request-manager';
import { ViewManager } from './view-manager'
import { addUserInfoToSummarize } from './url-creator'

const viewManager = new ViewManager();

export const getAllUserInfo = () => {
        const
            requestManager = new RequestManager(),
            userInfo = {
                userIp: null,
                userCountry: null
            };

        const handler = () => {
            getJSON('https://json.geoiplookup.io/', function (error, response){

              userInfo.userIp = response.ip;
              userInfo.userCountry = response.country_name;

              viewManager.updateUserInfo(userInfo);
              addUserInfoToSummarize(userInfo);
            })
            }


            handler();
        }
